
import React from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

// import './categoryLinkImage.scss'

export default function CategoryLinkImage({ to, src, alt }) {
    return (
        <Link to={to} className="category-link-image">
            <img src={src} alt={alt} />
            <FontAwesomeIcon icon={faChevronRight} />
        </Link>
    )
}